import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2 } from 'lucide-react';
import LegalPageLayout from '../componnents/LegalPageLayout/LegalPageLayout';
import LegalSection from '../componnents/LegalPageLayout/LegalSection';
import LegalContactBlock from '../componnents/LegalPageLayout/LegalContactBlock';

const About = () => {
  const { t } = useTranslation('about');

  return (
    <LegalPageLayout
      icon={Building2}
      title={t('title')}
      subtitle={t('subtitle')}
      backLabel={t('backToHome')}
    >
      <LegalSection>
        <p>{t('intro')}</p>
      </LegalSection>

      <LegalSection title={t('mission.title')}>
        <p>{t('mission.body')}</p>
      </LegalSection>

      <LegalSection title={t('marketplace.title')}>
        <p>{t('marketplace.body')}</p>
      </LegalSection>

      <LegalContactBlock
        title={t('contact.title')}
        description={t('contact.description')}
      />
    </LegalPageLayout>
  );
};

export default About;
